import CustomFormat from '@/helpers/custom-format'

export default {
  filtro: {
    status: function(grupoList, selecionado) {
      if (!selecionado || selecionado.ativo == null || selecionado == '') {
        return grupoList;
      } else {
        return grupoList.filter((grupo) => {
          return grupo.ativo == selecionado.ativo;
        });
      }
    },
    busca: function(grupoList, pesquisa) {
      if (!pesquisa || pesquisa == '') {
        return grupoList;
      } else {
        return grupoList.filter((grupo) => {
          return CustomFormat.removerAcentos(grupo.nome).includes(CustomFormat.removerAcentos(pesquisa));
        });
      }
    },
    /*,
    pagina: function(grupoList, paginacao) {
      var maxLength = (paginacao.pagina * paginacao.numElementosPagina);
      var minLength = (maxLength - paginacao.numElementosPagina);
      return grupoList.slice(minLength, maxLength);
    },
    paginaResize: function(grupoList, paginacao, filtro) {
      if (filtro.pesquisa != '' && (filtro.status == null || filtro.status == '')) {
        paginacao.pagina = 1;
        paginacao.numPaginas = parseInt(grupoList.length/15) + 1;
      }
      return paginacao;
    }*/
  },
  formatacao: {
    formataStringUsuarios: function (grupoModel) {
      let stringUsuarios = '';
      for (let i = 0; i < grupoModel.usuarios.length; i++) {
        if (i == 0) {
          stringUsuarios += grupoModel.usuarios[i].nome
        } else {
          stringUsuarios += ', ' + grupoModel.usuarios[i].nome
        }
      }
      return stringUsuarios;
    },
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/grupo-usuarios/functions.js